import VCProfile from './VCProfile';

export default VCProfile;
